const authorization = {
  // Page titles
  pageTitle: 'تفويض المنصة',
  pageSubtitle: 'فوّض منصة صفقات 24 لتسويق عقارك',

  // Stepper steps
  steps: {
    consent: 'الموافقة',
    authType: 'نوع التفويض',
    identity: 'التحقق من الهوية',
    ownership: 'إثبات الملكية',
    property: 'بيانات العقار',
    details: 'تفاصيل العقار',
    contact: 'التواصل',
    declarations: 'الإقرارات',
    signature: 'التوقيع',
  },

  // Step 1: Consent
  consent: {
    title: 'الموافقة على التفويض',
    subtitle: 'يرجى قراءة الشروط والموافقة عليها للمتابعة',
    agreement: 'أقر بأنني مالك العقار أو وكيل معتمد عن المالك، وأفوض منصة صفقات 24 للقيام بعمليات التسويق والإعلان عن عقاري وفقاً للشروط والأحكام المحددة.',
    termsTitle: 'شروط وأحكام التفويض',
    terms: [
      'تلتزم المنصة بعرض العقار وفقاً للمعلومات المقدمة من المالك',
      'يحق للمنصة إجراء تعديلات تحريرية على الوصف لتحسين جودة الإعلان',
      'تلتزم المنصة بعدم مشاركة بيانات المالك مع أطراف ثالثة دون إذن',
      'يمكن للمالك إلغاء التفويض في أي وقت',
      'تُطبق عمولة المنصة المتفق عليها في حال إتمام الصفقة',
    ],
    acceptTerms: 'أوافق على الشروط والأحكام',
    acceptRequired: 'يجب الموافقة على الشروط للمتابعة',
  },

  // Step 2: Authorization Type
  authType: {
    title: 'نوع التفويض',
    subtitle: 'اختر نوع التفويض الذي يناسب احتياجاتك',
    types: {
      adOnly: {
        title: 'إعلان فقط',
        description: 'تفويض المنصة لنشر إعلان العقار فقط',
        features: ['نشر الإعلان', 'الرد على الاستفسارات', 'تحديث البيانات'],
      },
      adMarketing: {
        title: 'إعلان + تسويق',
        description: 'تفويض شامل للإعلان والتسويق النشط',
        features: ['كل مميزات الإعلان', 'تسويق نشط للعقار', 'إعلانات مميزة', 'تقارير دورية'],
      },
      fullService: {
        title: 'خدمة متكاملة',
        description: 'تفويض كامل يشمل التفاوض وإتمام الصفقة',
        features: ['كل مميزات التسويق', 'التفاوض نيابة عنك', 'ترتيب المعاينات', 'إتمام الصفقة'],
      },
    },
    recommended: 'موصى به',
  },

  // Step 3: Identity Verification
  identity: {
    title: 'التحقق من الهوية',
    subtitle: 'أدخل رقم هويتك الوطنية أو الإقامة (10 أرقام). سيصلك إشعار في تطبيق نفاذ على هاتفك.',
    nafathRequired: 'التحقق عبر نفاذ مطلوب لإتمام التفويض',
    comingSoon: 'قريباً',
    comingSoonDesc: 'التحقق عبر نفاذ سيكون متاحاً قريباً. يمكنك المتابعة الآن وسيتم التواصل معك لإتمام التحقق.',
    softGateNote: 'التحقق عبر نفاذ غير مفعّل حالياً. يمكنك متابعة إرسال العقار وسنطلب التحقق لاحقاً.',
    nationalIdLabel: 'رقم الهوية',
    nationalIdPlaceholder: '1xxxxxxxxx',
    verifying: 'جاري الإرسال...',
    verifyCta: 'بدء التحقق عبر نفاذ',
    skipForNow: 'تخطي مؤقتاً',
    continueWithNafath: 'التحقق عبر نفاذ',
  },

  // Step 4: Ownership Proof
  ownership: {
    title: 'إثبات الملكية',
    subtitle: 'أدخل بيانات الصك أو وثيقة الملكية',
    deedType: 'نوع المستند',
    deedTypes: {
      deed: 'صك ملكية',
      contract: 'عقد إيجار موحد',
      powerOfAttorney: 'وكالة شرعية',
    },
    deedNumber: 'رقم الصك',
    deedNumberPlaceholder: 'أدخل رقم الصك',
    deedDate: 'تاريخ الصك',
    ownerIdNumber: 'رقم هوية المالك',
    ownerIdNumberPlaceholder: 'أدخل رقم الهوية',
    uploadDeed: 'رفع صورة الصك',
    uploadDeedDescription: 'صورة واضحة من الصك أو المستند (اختياري)',
    dragDrop: 'اسحب الملف هنا أو',
    browse: 'استعرض',
    maxSize: 'الحد الأقصى: 10 ميجابايت',
    acceptedFormats: 'الصيغ المقبولة: PDF، JPG، PNG',
    uploadError: 'تعذّر رفع مستند الملكية. يرجى المحاولة مرة أخرى.',
  },

  // Step 5: Property Details
  property: {
    title: 'بيانات العقار',
    subtitle: 'أدخل معلومات العقار المراد تفويضه',
    propertyType: 'نوع العقار',
    propertyTypes: {
      apartment: 'شقة',
      villa: 'فيلا',
      land: 'أرض',
      building: 'عمارة',
      office: 'مكتب',
      shop: 'محل تجاري',
    },
    listingType: 'نوع الإعلان',
    listingTypes: {
      sale: 'بيع',
      rent: 'إيجار',
    },
    city: 'المدينة',
    district: 'الحي',
    address: 'العنوان التفصيلي',
    addressPlaceholder: 'مثال: شارع الملك فهد، بجوار مركز...',
    price: 'السعر المطلوب',
    pricePlaceholder: 'أدخل السعر',
    negotiable: 'السعر قابل للتفاوض',
    area: 'المساحة (م²)',
    areaPlaceholder: 'أدخل المساحة',
    rooms: 'غرف النوم',
    bathrooms: 'دورات المياه',
    description: 'وصف العقار',
    descriptionPlaceholder: 'اكتب وصفاً تفصيلياً للعقار...',
    photos: 'صور العقار',
    photosDescription: 'أضف صور واضحة للعقار (يفضل 5 صور على الأقل)',
  },

  // Step 6: Contact Preferences
  contact: {
    title: 'تفضيلات التواصل',
    subtitle: 'كيف تريد التعامل مع الاستفسارات؟',
    // تُعرض للإعلانات المنشورة تحت رخصة المنصة بدلاً من اختيار المالك لجهة
    // التواصل — صفقات24 هي جهة التواصل الوحيدة.
    falManaged: {
      title: 'صفقات 24 تتولى جميع الاستفسارات',
      body: 'لأن هذا الإعلان منشور تحت رخصة فال الخاصة بصفقات 24، يتواصل المهتمون بالشراء أو الإيجار مع صفقات 24 مباشرةً وليس معك. يدير فريقنا كل استفسار ويوافيك بأي عروض أو رسائل مهمة.',
    },
    inquiryHandler: 'من يستقبل الاستفسارات؟',
    handlers: {
      platform: 'المنصة تستقبل وترد',
      owner: 'أستقبل الاستفسارات مباشرة',
      both: 'المنصة تصفي وتحول المهم',
    },
    ownerPhone: 'رقم جوال المالك',
    ownerPhonePlaceholder: '05xxxxxxxx',
    ownerEmail: 'البريد الإلكتروني',
    ownerEmailPlaceholder: 'example@email.com',
    preferredTime: 'أوقات التواصل المفضلة',
    times: {
      anytime: 'أي وقت',
      morning: 'صباحاً (8ص - 12م)',
      afternoon: 'ظهراً (12م - 5م)',
      evening: 'مساءً (5م - 9م)',
    },
    showPhone: 'إظهار رقم الجوال في الإعلان',
    showPhoneDescription: 'سيظهر رقمك للمهتمين في الإعلان',
  },

  // Step 7: Legal Declarations
  declarations: {
    title: 'الإقرارات القانونية',
    subtitle: 'يرجى قراءة والموافقة على الإقرارات التالية',
    items: [
      {
        id: 'ownership',
        title: 'إقرار الملكية',
        text: 'أقر بأنني المالك الشرعي للعقار أو مخول قانونياً بالتصرف فيه',
      },
      {
        id: 'accuracy',
        title: 'دقة المعلومات',
        text: 'أقر بأن جميع المعلومات المقدمة صحيحة ودقيقة',
      },
      {
        id: 'disputes',
        title: 'خلو من النزاعات',
        text: 'أقر بأن العقار خالٍ من أي نزاعات قانونية أو رهونات',
      },
      {
        id: 'commission',
        title: 'الموافقة على العمولة',
        text: 'أوافق على نسبة العمولة المحددة في حال إتمام الصفقة عبر المنصة',
      },
    ],
    acceptAll: 'الموافقة على جميع الإقرارات',
  },

  // Step 8: Signature
  signature: {
    title: 'التوقيع الإلكتروني',
    subtitle: 'وقّع على التفويض إلكترونياً',
    absherRequired: 'التوقيع عبر أبشر مطلوب لإتمام التفويض',
    comingSoon: 'قريباً',
    comingSoonDesc: 'التوقيع الإلكتروني عبر أبشر سيكون متاحاً قريباً. يمكنك المتابعة الآن وسيتم التواصل معك لإتمام التوقيع.',
    skipForNow: 'إرسال بدون توقيع إلكتروني',
    signWithAbsher: 'التوقيع عبر أبشر',
    manualSignature: 'التوقيع اليدوي',
    manualSignatureDesc: 'ارسم توقيعك في المربع أدناه',
    canvasHint: 'استخدم الماوس أو إصبعك للتوقيع',
    clear: 'مسح',
    agreementText: 'بتوقيعي أدناه، أقر بموافقتي على جميع الشروط والأحكام وصحة المعلومات المقدمة.',
  },

  // Success
  success: {
    title: 'تم استلام طلب التفويض',
    subtitle: 'سنراجع طلبك ونتواصل معك خلال 24 ساعة',
    referenceNumber: 'رقم الطلب',
    whatNext: 'الخطوات التالية',
    steps: [
      'مراجعة الطلب من فريقنا',
      'التواصل معك لتأكيد البيانات',
      'نشر الإعلان بعد الموافقة',
    ],
    viewStatus: 'متابعة حالة الطلب',
    submitAnother: 'تفويض عقار آخر',
    backToHome: 'العودة للرئيسية',
  },

  // Actions
  actions: {
    next: 'التالي',
    back: 'السابق',
    submit: 'إرسال التفويض',
    submitting: 'جاري الإرسال...',
    cancel: 'إلغاء',
    save: 'حفظ كمسودة',
  },

  // Validation
  validation: {
    consentRequired: 'يجب الموافقة على الشروط',
    authTypeRequired: 'يرجى اختيار نوع التفويض',
    deedRequired: 'يرجى إدخال بيانات الصك',
    propertyRequired: 'يرجى إدخال بيانات العقار',
    contactRequired: 'يرجى إدخال بيانات التواصل',
    declarationsRequired: 'يرجى الموافقة على جميع الإقرارات',
  },
};

export default authorization;
